/* eslint-disable max-lines-per-function */
(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('CronogramaFungicidasCreateCtrl', CronogramaFungicidasCreateController);

  CronogramaFungicidasCreateController.$inject = [
    '$scope',
    'CronogramaFungicidasService',
    'atividades',
    'atividade',
    'safra',
    'MessagesService',
    '$rootScope',
    'gleba',
    'DATE_MASK',
    'RecomendacoesService',
    'LoadingService',
    'PlantiosService',
    'DataService',
    'EmpreendimentosService',
    'InformacoesCultivaresService',
    'ItensService'
  ];

  // eslint-disable-next-line max-params, max-lines-per-function
  function CronogramaFungicidasCreateController($scope, CronogramaFungicidasService, atividades, atividade, safra,
    MessagesService, $rootScope, gleba, DATE_MASK, RecomendacoesService, LoadingService, PlantiosService, DataService,
    EmpreendimentosService, InformacoesCultivaresService, ItensService) {
    const vm = this;

    // Controller data
    vm.formWarnings = {};
    vm.messages = {};
    vm.loading = false;
    vm.cronograma = {
      safra: _.find($rootScope.safras, { id: safra.id }) || null,
      gleba: null,
      atividade: null,
      cultivar: null,
      plantio: null,
      ciclo: null,
      emergencia: null,
      first: null,
      quantidade: null,
      intervalo: 15,
      area: null,
      colheitaEstimada: null
    };
    vm.datepickerTextArea = {
      plantio: '',
      emergencia: '',
      first: '',
      colheitaEstimada: ''
    };
    vm.atividades = [];
    vm.cultivaresAtividade = [];
    vm.cultivares = [];
    vm.infoCultivares = [];
    vm.glebasAtividade = [];
    vm.plantioDates = null;
    vm.datepickerPlantio = {
      open: false
    };
    vm.datapickerPlantioOptions = {
      showWeeks: false,
      customClass: (obj) => DataService.getDatePickerCustomClass(obj, vm.plantioDates)
    };

    vm.datepickerEmergencia = {
      open: false
    };
    vm.datepickerFirst = {
      open: false
    };
    vm.datepickerOptions = {
      showWeeks: false
    };
    vm.daysFromEmergence = 15;
    vm.DATE_MASK = DATE_MASK;
    vm.empreendimentos = [];
    vm.datepickerColheitaEstimada = {
      open: false
    };
    vm.plantios = [];

    // Bindable methods
    vm.save = save;
    vm.updateFirstApplicationDate = updateFirstApplicationDate;
    vm.setCronogramaDate = setCronogramaDate;
    vm.setTextDatapicker = setTextDatapicker;
    vm.changeSafra = changeSafra;
    vm.changeAtividade = changeAtividade;
    vm.changeGleba = changeGleba;
    vm.changeCultivar = changeCultivar;
    vm.changePlantioCiclo = changePlantioCiclo;

    // Function declarations
    function save() {
      vm.loading = true;
      return CronogramaFungicidasService.createNew(vm.cronograma)
        .then(() => {
          MessagesService.alert('Novo cronograma criado com sucesso!');
          $scope.$close();
        })
        .catch((error) => {
          if (typeof error.data === 'string') {
            MessagesService.alert(error.data);
          } else {
            MessagesService.alert('Erro ao criar cronograma. Verifique os dados e tente novamente.');
          }
        })
        .finally(() => {
          vm.loading = false;
        });
    }

    function setCronogramaDate(type) {
      const textInputValue = (vm.datepickerTextArea[type] || '').replace(/_/g, '');
      if (textInputValue.length === 10) {
        vm.cronograma[type] = new Date(moment(textInputValue, 'DD/MM/YYYY').format());
      } else {
        vm.cronograma[type] = null;
      }
    }

    function setTextDatapicker(type) {
      if (!vm.cronograma[type]) {
        vm.datepickerTextArea[type] = '';
      } else {
        vm.datepickerTextArea[type] = moment(vm.cronograma[type]).format('DD/MM/YYYY');
      }
    }

    function updateFirstApplicationDate(type) {
      switch (type) {
      case 'emergence':
      case 'days':
        vm.cronograma.first = moment(vm.cronograma.emergencia)
          .add(vm.daysFromEmergence, 'days')
          .toDate();
        setTextDatapicker('first');
        break;
      case 'first':
        vm.daysFromEmergence = Math.max(moment(vm.cronograma.first).diff(vm.cronograma.emergencia, 'days'), 0);
        break;
      }
      calcColheitaEstimada();
    }

    function changeSafra() {
      resetAtividade();
      getAtividadesPeriodo();
    }

    function resetAtividade() {
      vm.atividades = [];
      vm.cronograma.atividade = null;
      vm.changeAtividade();
    }

    async function changeAtividade() {
      vm.glebasAtividade = [];
      if (vm.cronograma.atividade) {
        const atividadeSelecionada = vm.cronograma.atividade;
        try {
          const data = await ItensService.listCultivares({
            atividade: atividadeSelecionada.id
          });
          vm.cultivares = vm.cultivaresAtividade = data.data;
        } catch (error) {
          vm.messages.error = 'Falha ao carregar cultivares';
          console.error('Falha ao carregar cultivares', error);
        }

        if (atividadeSelecionada.glebas) {
          vm.glebasAtividade = RecomendacoesService.listGlebas(atividadeSelecionada.glebas);
        } else {
          vm.glebasAtividade = $rootScope.currentPropriedade.glebas;
        }
      }
      updatePlantiosData();
      getEmpreendimentoAtividade();
    }

    function getEmpreendimentoAtividade() {
      if (vm.cronograma.safra && vm.cronograma.atividade) {
        LoadingService.showLoading();
        const filters = {
          safra: vm.cronograma.safra.id,
          propriedade: $rootScope.currentPropriedade.id,
          atividade: vm.cronograma.atividade.id
        };

        EmpreendimentosService.list(filters)
          .then(function({ data }) {
            vm.empreendimentos = data;

            CronogramaFungicidasService.setGlebaAreaEmpreendimento(vm.cronograma.gleba, data);
          })
          .catch(function(error) {
            MessagesService.alert('Ocorreu um erro ao buscar os empreendimentos da safra selecionada.');
            console.error(error);
          })
          .finally(LoadingService.hideLoading);
      }
    }

    function setPlantioDates(plantios) {
      vm.plantioDates = plantios.reduce((result, plantio) => {
        const dataFim = plantio.data_fim;
        if (dataFim) {
          result.datas.push(dataFim);
          result.meses.push(dataFim.substring(0, 7));
          result.anos.push(dataFim.substring(0, 4));
        }

        return result;
      }, {
        datas: [],
        meses: [],
        anos: []
      });
    }

    async function changeGleba() {
      vm.cronograma.cultivar = null;
      resetPlantio();
      resetInfoCultivares();
      try {
        await updatePlantiosData();
      } catch (error) {
        console.warn('Não foi possível encontrar plantios para o talhão selecionado', error);
      }
      setInfoCultivares();
      CronogramaFungicidasService.setGlebaAreaEmpreendimento(vm.cronograma.gleba, vm.empreendimentos);
      calcColheitaEstimada();
    }

    function changePlantioCiclo() {
      calcColheitaEstimada();
    }

    function selecionaAreaGlebaOuEmpreendimento() {
      const glebaSelecionada = _.find(vm.glebasAtividade, { id: vm.cronograma.gleba.id });
      const empreendimento = _.find(vm.empreendimentos[0].empreendimento_glebas, { cd_gleba: vm.cronograma.gleba.id });
      const area = empreendimento ? empreendimento.area : glebaSelecionada.area;
      return parseFloat(area);
    }

    function setPlantio(plantio) {
      if (plantio && plantio.data_fim) {
        vm.cronograma.plantio = moment(plantio.data_fim).toDate();
        vm.cronograma.area = parseFloat(plantio.area);
        vm.cronograma.gleba.areaPlantio = parseFloat(plantio.area);
      } else {
        vm.cronograma.area = selecionaAreaGlebaOuEmpreendimento();
      }
    }

    function resetPlantio() {
      vm.cronograma.plantio = null;
      vm.cronograma.area = null;
      setTextDatapicker('plantio');
    }

    function updateInfoCultivares() {
      const plantio = _.find(vm.plantios, { insumo_id: (vm.cronograma.cultivar || {}).item_id });
      setPlantio(plantio);

      const informacao = _.find(vm.infoCultivares, { cd_insumo: vm.cronograma.cultivar.item_id });

      if (informacao) {
        vm.cronograma.ciclo = informacao.ciclo_dias || 0;
        vm.cronograma.emergencia = moment(informacao.data_emergencia).toDate();
        vm.cronograma.colheitaEstimada = informacao.data_estimada_colheita;

        calcColheitaEstimada();

        setTextDatapicker('emergencia');
      } else {
        resetInfoCultivares();
      }
    }

    function resetInfoCultivares() {
      vm.cronograma.ciclo = 0;
      vm.cronograma.emergencia = null;
      vm.cronograma.colheitaEstimada = null;
      ['emergencia', 'colheitaEstimada'].forEach(setTextDatapicker);
    }

    function setInfoCultivares() {
      vm.infoCultivares = [];
      if (!vm.cronograma.atividade || !vm.cronograma.gleba) {
        return;
      }

      return InformacoesCultivaresService.get({
        safra: (vm.cronograma.safra || {}).id,
        atividade: vm.cronograma.atividade.id,
        gleba: vm.cronograma.gleba.id
      }).then((result) => {
        vm.infoCultivares = result.data;
        updateInfoCultivares();
      })
        .catch((error) => {
          vm.cronograma.cultivar = null;
          resetInfoCultivares();
          vm.messages.warning = 'Não foram encontrados dados do ciclo para a cultivar do plantio.';
          setTimeout(() => {
            vm.messages.warning = null;
            $scope.$apply();
          }, 5000);
          // eslint-disable-next-line no-console
          console.warn(
            'Erro ao listar informações de cultivares - possivelmente não encontrou informações registradas', error
          );
        });
    }

    function changeCultivar() {
      updateInfoCultivares();
    }

    // eslint-disable-next-line max-lines-per-function
    function updatePlantiosData() {
      vm.plantios = [];
      vm.plantioDates = null;

      if (!vm.cronograma.atividade || !vm.cronograma.gleba) {
        return;
      }
      return PlantiosService.getPlantioSimples({
        onlyActive: true,
        safra: (vm.cronograma.safra || {}).id,
        atividade: vm.cronograma.atividade.id,
        gleba: vm.cronograma.gleba.id
      }).then(({ data: plantios }) => {
        vm.cronograma.plantio = null;
        vm.cronograma.area = null;
        vm.plantios = plantios;

        const cultivares = plantios
          .flatMap((plantio) => _.filter(vm.cultivaresAtividade, { item_id: plantio.insumo_id }));

        if (cultivares.length > 0) {
          vm.cultivares = cultivares;
        } else {
          vm.cultivares = vm.cultivaresAtividade;
        }
        const [plantio] = plantios;
        const cultivar = _.find(vm.cultivares, { item_id: (plantio || {}).insumo_id });
        vm.cronograma.cultivar = cultivar;
        if (plantios.length) {
          setPlantio(plantio);
        } else {
          $scope.form.plantio.$setPristine(true);
          setPlantioDates(plantios);
          const sumAreaPlantios = _.sumBy(plantios, (semeadura) => parseFloat(semeadura.area));
          vm.cronograma.area = sumAreaPlantios;
          vm.cronograma.gleba.areaPlantio = parseFloat(sumAreaPlantios);
        }
        setTextDatapicker('plantio');
      });
    }

    function calcColheitaEstimada() {
      const emergencia = vm.cronograma.emergencia;
      const cicloDias = vm.cronograma.ciclo;

      if (emergencia && cicloDias) {
        vm.cronograma.colheitaEstimada = moment(emergencia, 'DD-MM-YYYY')
          .add(cicloDias, 'days')
          .toDate();
      } else {
        vm.cronograma.colheitaEstimada = '';
      }

      setTextDatapicker('colheitaEstimada');
    }

    function getAtividadesPeriodo() {
      if (vm.cronograma.safra) {
        LoadingService.showLoading();
        const filters = {
          safra: (vm.cronograma.safra || {}).id,
          propriedade: $rootScope.currentPropriedade.id
        };

        RecomendacoesService.listAtividadesPeriodo(filters)
          .then(function(data) {
            if (data.length) {
              vm.atividades = data;
            } else {
              vm.atividades = atividades;
            }
          })
          .catch(function() {
            MessagesService.alert('Ocorreu um erro ao buscar as culturas da safra selecionada.');
          })
          .finally(LoadingService.hideLoading);
      }
    }


    // Controller logic
    if (atividade) {
      vm.cronograma.atividade = _.find(atividades, { id: atividade.id });
    }
    if (gleba) {
      vm.cronograma.gleba = _.find($rootScope.currentPropriedade.glebas, { id: gleba.id });
    }
    if (vm.cronograma.safra) {
      vm.changeSafra();
    }

    $scope.$watch(
      '$create.cronograma',
      (newValue) => vm.formWarnings = CronogramaFungicidasService.checkFormWarnings(newValue),
      _.isEqual
    );
  }
}());
